export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Industrial Instrumentation Educator — London, United Kingdom',
    'My students finally understand the difference between measurement principles, sensors and transducers, industrial signals, and process control fundamentals. I used to waste hours searching for the right way to explain how industrial instrumentation actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain 4–20 mA scaling, temperature measurement, pressure sensors, control loops, PLC concepts, or how to teach diagnostic reasoning in instrumentation contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Industrial Instrumentation and Process Control Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated industrial instrumentation projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Industrial Instrumentation Educator | London, United Kingdom',
    "The material on measurement principles and sensor technology completely changed how my students understand industrial instrumentation. They finally grasp how transmitters convert physical measurements into industrial signals. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Industrial Instrumentation Teacher | Berlin, Germany',
    "The 50 instrumentation projects transformed how my students see real-world applications. Now they analyze control loops, understand PLC integration, evaluate sensor selection, and grasp why instrumentation knowledge matters professionally and in real automation systems. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The industrial instrumentation terminology handbook gave me back my class time. I used to spend time explaining instrumentation concepts and misconceptions. Now I show the handbook and students instantly understand instrumentation concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Industrial Instrumentation Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real instrumentation challenges, evaluating measurement accuracy, exploring sensor selection, and understanding how instrumentation analysis contributes to process control. This completely transformed how they see industrial instrumentation.",
  ],
];
